"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CustomDesign_vue_1 = __importDefault(require("../../pages/customDesign/CustomDesign.vue"));
exports.default = [
    {
        name: "custom_design",
        path: "/custom-design",
        component: CustomDesign_vue_1.default,
        meta: { requiresAuth: true, title: "Custom Design" },
    },
    {
        name: 'save_design_api',
        path: '/api/customers/save-design/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    },
    {
        name: 'remove_design_api',
        path: '/api/customers/remove-design/:id(\\d+)?',
        redirect: '',
        meta: { requiresAuth: true }
    }
];
